export const config = {
  apiBaseUrl: import.meta.env.VITE_API_BASE_URL ?? "http://127.0.0.1:8787",
  wsBaseUrl: import.meta.env.VITE_WS_BASE_URL ?? "ws://127.0.0.1:8787/ws",
  environment: import.meta.env.VITE_ENVIRONMENT ?? "dev",
};
